/**
 * Le parole dell’elenco dei contenuti ad albero: lingue, traduzioni mancanti,
 * sezioni e conteggi.
 */
import type { DictNode } from './dict.js'

export const contentTreeIt: DictNode = {
  contentTree: {
    treeLabel: 'Struttura del sito',
    language: 'Lingua mostrata',
    languageHelp: 'Si vede una sola lingua alla volta; le traduzioni sono indicate su ogni voce.',
    expandAll: 'Apri tutto',
    collapseAll: 'Chiudi tutto',
    countOne: '1 contenuto',
    countMany: '{{n}} contenuti',
    summary: '{{shown}} di {{total}} contenuti in {{language}}',
    summaryAll: '{{total}} contenuti in {{language}}',
    loadingProgress: 'Caricati {{done}} di {{total}} contenuti…',
    truncated: 'Sono mostrati i primi {{n}} contenuti: restringi la ricerca per trovare gli altri.',
    missing: 'manca {{lang}}',
    missingHelp: 'Questo contenuto non ha ancora una versione in {{language}}.',
    translationHelp: '{{language}}: «{{title}}» ({{status}}). Apri la versione.',
    otherLanguages: 'Solo in altre lingue',
    otherLanguagesHelp: 'Contenuti senza una versione nella lingua mostrata, oppure non collegati alla sua traduzione.',
    openSection: 'Apri la sezione «{{name}}»',
    closeSection: 'Chiudi la sezione «{{name}}»',
    noTitle: 'Senza titolo',
    emptyTree: 'Nessun contenuto in questa lingua.',
    emptyTreeHelp: 'Scegli un’altra lingua o togli i filtri.',
  },
}

export const contentTreeEn: DictNode = {
  contentTree: {
    treeLabel: 'Site structure',
    language: 'Language shown',
    languageHelp: 'One language at a time; translations are marked on each item.',
    expandAll: 'Open all',
    collapseAll: 'Close all',
    countOne: '1 content',
    countMany: '{{n}} contents',
    summary: '{{shown}} of {{total}} contents in {{language}}',
    summaryAll: '{{total}} contents in {{language}}',
    loadingProgress: 'Loaded {{done}} of {{total}} contents…',
    truncated: 'Showing the first {{n}} contents: narrow the search to find the others.',
    missing: '{{lang}} missing',
    missingHelp: 'This content has no version in {{language}} yet.',
    translationHelp: '{{language}}: “{{title}}” ({{status}}). Open that version.',
    otherLanguages: 'Only in other languages',
    otherLanguagesHelp: 'Contents with no version in the language shown, or not linked to its translation.',
    openSection: 'Open the section “{{name}}”',
    closeSection: 'Close the section “{{name}}”',
    noTitle: 'Untitled',
    emptyTree: 'No content in this language.',
    emptyTreeHelp: 'Choose another language or clear the filters.',
  },
}
